export const createIcon = (Svg: React.FC) => {
  return (props: React.SVGProps<SVGSVGElement>) => <Svg {...props} />;
};

export default createIcon;
